import { render } from "./Licences.vue?vue&type=template&id=5b934764&scoped=true"
import script from "./Licences.vue?vue&type=script&lang=js"
export * from "./Licences.vue?vue&type=script&lang=js"

import "./Licences.vue?vue&type=style&index=0&id=5b934764&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b934764"]])

export default __exports__